import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BodyType = ({ bodyType }: SpecProps<"body_type">) => {
  const { i18n } = useLingui();

  if (!bodyType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.body_type",
    message: "Body type",
    comment: "Field for 'body type' in ad specification",
  });

  return <FieldValuePair field={field} value={bodyType} />;
};
